import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { MarkdownView } from '@components/help/MarkdownView';

interface Props {
  /** Markdown já carregado (src/docs/legal/*.md via `?raw`). */
  source: string;
  /** Link para o outro documento legal (Termos ↔ Privacidade). */
  sibling: { to: string; label: string };
}

/**
 * Página pública (sem login, sem menu) para os textos legais — Política de privacidade e Termos de
 * uso. Mesmo visual do login: fundo degradê e cartão branco; o conteúdo vem do markdown em
 * `src/docs/legal/` (fora da cobertura da Central de ajuda).
 */
export const LegalPage: React.FC<Props> = ({ source, sibling }) => (
  <div className="min-h-screen gradient-login-bg p-4 sm:p-8">
    <div className="w-full max-w-3xl mx-auto">
      <div className="bg-white rounded-xl shadow-card p-5 sm:p-8 animate-slide-up">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <Link to="/login" className="inline-flex items-center gap-2 min-w-0 text-slate-700 hover:text-emerald-700">
            <img src="/plan_logo.svg" alt="Plan" className="w-9 h-9 rounded-lg flex-shrink-0" />
            <span className="font-semibold truncate">Plan — Giannotti</span>
          </Link>
          <Link to={sibling.to} className="text-sm text-emerald-700 hover:underline">
            {sibling.label}
          </Link>
        </div>

        <MarkdownView source={source} />

        <div className="mt-8 pt-4 border-t border-slate-200 flex flex-wrap items-center justify-between gap-3 text-sm">
          <Link to="/login" className="inline-flex items-center gap-1 text-emerald-700 hover:underline">
            <ArrowLeft size={14} /> Voltar ao login
          </Link>
          <a href="mailto:suporte@giannotti.com.br" className="text-slate-500 hover:text-emerald-700 [overflow-wrap:anywhere]">
            suporte@giannotti.com.br
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default LegalPage;
